import { createClient } from '@supabase/supabase-js';
import { getSupabaseAuthConfig } from '@atilum/config';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    '[Atilum] Missing Supabase env vars. Make sure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in .env.local'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    ...getSupabaseAuthConfig(),
    detectSessionInUrl: true,
  },
});

// Re-export all types from the shared package for backwards compatibility
export type {
  Profile,
  DailyQuestion,
  SubmitAnswerResult,
  ScoreHistoryEntry,
  Recommendation,
  UserRecommendation,
  RecommendationsResponse,
} from '@atilum/types';
